// extracted by mini-css-extract-plugin
export default {"loading":"view_loading__cwwF+"};